import type { Notification } from "@/shared/types";

/**
 * Uniform notification feed — every entry reads
 *   "<username> Posted 7 New updates."
 * Per app product spec: notifications surface creator activity bursts
 * rather than per-interaction events (likes/follows/etc).
 */
const NEW_UPDATES_TEXT = (username: string) => `${username} Posted 7 New updates.`;

export const NOTIFICATIONS: Notification[] = [
  { id: "n1",  kind: "post", actorId: "u1",  text: NEW_UPDATES_TEXT("elena.rose"),     createdAt: "2026-05-12T08:01:00Z", read: false },
  { id: "n2",  kind: "post", actorId: "u2",  text: NEW_UPDATES_TEXT("mia_muse"),       createdAt: "2026-05-12T07:30:00Z", read: false },
  { id: "n3",  kind: "post", actorId: "u5",  text: NEW_UPDATES_TEXT("sophia.art"),     createdAt: "2026-05-12T03:11:00Z", read: false },
  { id: "n4",  kind: "post", actorId: "u7",  text: NEW_UPDATES_TEXT("valerie.vogue"),  createdAt: "2026-05-11T22:00:00Z", read: true  },
  { id: "n5",  kind: "post", actorId: "u3",  text: NEW_UPDATES_TEXT("luna.v"),         createdAt: "2026-05-11T16:00:00Z", read: true  },
  { id: "n6",  kind: "post", actorId: "u9",  text: NEW_UPDATES_TEXT("emma.grace"),     createdAt: "2026-05-11T13:00:00Z", read: true  },
  { id: "n7",  kind: "post", actorId: "u4",  text: NEW_UPDATES_TEXT("aria.fit"),       createdAt: "2026-05-10T18:00:00Z", read: true  },
  { id: "n8",  kind: "post", actorId: "u10", text: NEW_UPDATES_TEXT("jade.shadows"),   createdAt: "2026-05-10T11:00:00Z", read: true  },
  { id: "n9",  kind: "post", actorId: "u8",  text: NEW_UPDATES_TEXT("scarlett.j"),     createdAt: "2026-05-09T20:00:00Z", read: true  },
  { id: "n10", kind: "post", actorId: "u11", text: NEW_UPDATES_TEXT("noor.hue"),       createdAt: "2026-05-09T08:00:00Z", read: true  },
];
